"use client";

import React from "react";
import { Car, MapPin, TrainFront } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locationData = {
  address: "West Palm Beach, FL, USA",
  mapUrl: "https://maps.google.com/maps?q=West%20Palm%20Beach,%20FL&t=&z=11&ie=UTF8&iwloc=&output=embed"
};
const infoCards = [{
  title: "Local Coverage",
  description: "Joss provides dedicated in-person birth and postpartum support throughout West Palm Beach, Palm Beach Gardens, and Jupiter, Florida.",
  icon: MapPin
}, {
  title: "Travel Support",
  description: "Available for travel doula services for families outside of Palm Beach County, ensuring professional care is accessible wherever you are.",
  icon: TrainFront
}, {
  title: "Service Areas",
  description: "Primary service areas include zip codes 33401, 33405, 33407, 33409, 33411, and 33417, as well as surrounding coastal communities.",
  icon: Car
}];
export default function DoveTrovarci() {
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223399" id="our-support-area" className="w-full bg-background flex flex-col">
      {}
      <div className="w-full h-[400px] md:h-[500px] lg:h-[600px] relative bg-muted border-b border-border">
        <iframe title="Map of Birthing Joy service area in West Palm Beach" src={locationData.mapUrl} className="w-full h-full border-0 grayscale opacity-80 contrast-100 dark:opacity-60 dark:invert dark:hue-rotate-180" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        {}
        <div className="absolute inset-0 pointer-events-none bg-chart-1/10 dark:bg-chart-1/20 mix-blend-multiply" />
      </div>

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl font-bold text-foreground mb-4 tracking-tight !font-serif md:text-4xl lg:text-5xl">
            Our Support Area
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            Birthing Joy proudly serves families in West Palm Beach and the surrounding coastal communities. Here is where you can find Jocelyn’s expert care.
          </p>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {infoCards.map((card, index) => {
          const Icon = card.icon;
          return <Card key={index} data-index={index} className="bg-card border-border shadow-sm hover:shadow-md transition-shadow duration-300 h-full flex flex-col rounded-3xl">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-chart-1/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-secondary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default text-xl md:text-2xl text-card-foreground">
                    {card.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex-grow">
                  <p className="text-muted-foreground font-default leading-relaxed">
                    {card.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}